import React from "react";
import "./Panchanga.css";

export default function Panchanga() {
  return (
    <div className="panchanga-page">
      {/* ── Same star background as hero ── */}
      <div className="stars-layer" aria-hidden="true">
        {Array.from({ length: 60 }).map((_, i) => (
          <span
            key={i}
            className="star"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              width: `${Math.random() * 3 + 1}px`,
              height: `${Math.random() * 3 + 1}px`,
            }}
          />
        ))}
      </div>

      {/* ── Same mandala decoration ── */}
      <div className="hero-mandala" aria-hidden="true">
        <div className="mandala-ring ring-1" />
        <div className="mandala-ring ring-2" />
        <div className="mandala-ring ring-3" />
        <span className="mandala-om">ॐ</span>
      </div>

      <div className="panchanga-container">
        <h1 className="panchanga-title">पञ्चाङ्ग</h1>
        <p className="panchanga-sub">आजको तिथि, वार, नक्षत्र, योग र करण</p>
        <div className="panchanga-widget">
          <iframe
            src="https://www.ashesh.com.np/panchang/widget.php?header_title=Nepali Panchang&header_color=e6e5e2&api=311146q432"
            frameBorder="0"
            scrolling="no"
            marginWidth="0"
            marginHeight="0"
            style={{
              border: "none",
              overflow: "hidden",
              width: "100%",
              height: "365px",
              borderRadius: "10px",
            }}
            allowTransparency="true"
            title="Nepali Panchang"
          />
          <span className="panchanga-credit">
            ©{" "}
            <a
              href="https://www.ashesh.com.np/panchang/"
              title="Panchang"
              target="_top"
            >
              Panchang
            </a>
          </span>
        </div>
      </div>
    </div>
  );
}
